import { Component, ViewChild, AfterViewInit, inject, ChangeDetectorRef } from '@angular/core';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { Router } from '@angular/router';
import { BenefitGroupService } from '../../../services/benefit-group.service';
import { FilterBenefitGroup } from '../../../models/filters/filter-benefit-group';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-benefits',
  standalone: false,
  templateUrl: './benefits.component.html',
  styleUrl: './benefits.component.css'
})

export class BenefitsComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    throw new Error('Method not implemented.');
  }

  @ViewChild(TableComponent) benefitsTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterBenefitGroup: FilterBenefitGroup = new FilterBenefitGroup;
  advancedSearch: boolean = false;
  
  private benefitGroupService = inject(BenefitGroupService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterBenefitGroup = new FilterBenefitGroup();
    this.searchBenefitGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchBenefitGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/benefitsGroup/edit', event.id]);
  }
  addNewBenefitGroup(){
    this.router.navigate(['/benefitsGroup/edit', 0]);
  }

  searchBenefitGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchBenefitGroupPaginator();
  }

  searchBenefitGroupPaginator(){
    this.loading = true;

    this.benefitGroupService.findAllPageableBenefitGroup(this.filterBenefitGroup, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.benefitsTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }

  

}